// console.log("👋")


// **********************************************************************
// PDP START DATES
// **********************************************************************
function startDates() {
	if (document.getElementsByClassName('js-date-select').length > 0) {
		document.querySelectorAll('.js-date-select').forEach(item => {
			item.addEventListener('change', event => {
				const dateSelect = event.target;
				const programme = dateSelect.dataset.programme;
				const course = dateSelect.value ? JSON.parse(dateSelect.value) : false;
				const courseContainer = document.querySelector('div[data-programme="' + programme + '"]');
				
				if(course) {
					const activeCohort = document.querySelector('ul[data-cohort="' + course.cohortId + '"]');
					const cohorts = courseContainer.querySelectorAll('ul[data-cohort]');

					cohorts.forEach(item => item.classList.remove('active'));

					accordion();
					activeCohort.classList.add('active');
					courseContainer.classList.add('pdp--date-selected');

					// Not ideal (new functionaliy after most stuff already built) - to save having to re-do lots of accordion suff this function tweaks the initial data value added to the accordion draw so it matches the height of the set of dates
					var activeDrawHeight = activeCohort.offsetHeight;
					activeCohort.closest('.js-accordion-draw').setAttribute('height', activeDrawHeight + 20);
				} 

				if(!course) {
					courseContainer.classList.remove('pdp--date-selected');
				}
			});
		});
	}
}


// **********************************************************************
// MODAL
// **********************************************************************
function contentTriggers() {
	const buttonTriggers = document.getElementsByClassName('js-content-triggers');
	
	if (buttonTriggers.length = 0) return 0

	for (const trigger of buttonTriggers) {
		const triggerID = trigger.getAttribute('data-target');
		const triggerWrapper = trigger.closest(".container");
		const targetContent = document.querySelector('[data-content='+triggerID+']');
		const restartLink = document.querySelector('.help-me-choose__restart');
		

		trigger.onclick = function() {
			restartLink.classList.add('active');

			triggerWrapper.classList.add('hidden');

			if (targetContent.classList.contains("active")) {
				targetContent.classList.remove("active")
			} else {
				targetContent.classList.add("active")
			}
		}
	}
}


// **********************************************************************
// MODAL
// **********************************************************************
function modal() {
	const modalTriggers = document.getElementsByClassName('js-modal-toggle');
	
	if (modalTriggers.length = 0) return 0

	for (const trigger of modalTriggers) {
		const triggerID = trigger.getAttribute('data-trigger-id');
		const targetModal = document.querySelector('[data-modal-id='+triggerID+']');

		trigger.onclick = function() {
			if (targetModal.classList.contains("modal--active")) {
				targetModal.classList.remove("modal--active")
			} else {
				targetModal.classList.add("modal--active")
			}
		}
	}
}


// **********************************************************************
// PULL HERO UP BEHIND HEADER
// **********************************************************************
function headerHeight() {
	const headerHeight = $('.header').outerHeight()
	
	if ($(".hero--first").length) {
		$('.header').addClass("header--overlay")
		$(".hero--first").css({
			'margin-top' : '-' + headerHeight + 'px',
			'padding-top' : headerHeight + 'px'
		});
	}
}

// **********************************************************************
// TOGGLE THE MOBILE NAV
// **********************************************************************
function navToggle() {
	if (window.innerWidth > 1250) return 0

	const navToggle = document.getElementsByClassName('js-nav-toggle');
	const nav = document.getElementsByClassName('site-nav')[0];
	const body = document.getElementsByClassName('body')[0];

	if (navToggle.length = 0) return 0
	if (nav.length = 0) return 0

	for (const toggle of navToggle) {
		toggle.onclick = function() {
			if (nav.classList.contains("site-nav--active")) {
				toggle.classList.remove("nav-toggle--active")
				nav.classList.remove("site-nav--active")
				body.classList.remove("body--fixed")
			} else {
				toggle.classList.add("nav-toggle--active")
				nav.classList.add("site-nav--active")
				body.classList.add("body--fixed")
			}
		}
	}
}

function accordion() {
	const accordionTrigger = document.getElementsByClassName('js-accordion-trigger');
	const accordionDraw = document.getElementsByClassName('js-accordion-draw');
	
	if (accordionTrigger.length = 0) return 0

	for (const draw of accordionDraw) {
		const drawHeight = draw.offsetHeight
		draw.setAttribute('height', drawHeight);
		draw.style.height = 0
	}

	for (const trigger of accordionTrigger) {
		const closestDraw = trigger.closest('.accordion__heading').nextElementSibling;

		trigger.classList.remove("accordion__button--active");

		trigger.onclick = function() {
			// The height is retreived on click so that the draw height can be amended on the fly if needed (PDP)
			const closestDrawHeight = closestDraw.getAttribute('height')

			if (trigger.classList.contains("accordion__button--active")) {
				trigger.classList.remove("accordion__button--active")
				closestDraw.style.height = 0
			} else {
				trigger.classList.add("accordion__button--active")
				closestDraw.style.height = closestDrawHeight + "px"
			}
		}
	}
}

const initCheckoutForm = () => {

	const form = document.querySelector('[data-checkout-form]');

	if ( ! form ) return;
	
	form.querySelectorAll('[data-proxy-target]').forEach(checkbox => {
		const target = form.querySelector('[name="' + checkbox.dataset.proxyTarget + '"]');
		checkbox.addEventListener('change', () => target.value = checkbox.checked ? 1 : 0);
	});
	
};

const initPaymentForm = () => {
	
	if (typeof window.stripe === 'undefined') return;
	
	const elements = window.stripe.elements();
	const style = {
		base: {
			color: '#32325d',
			fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
			fontSmoothing: 'antialiased',
			fontSize: '16px',
			'::placeholder': {
				color: '#aab7c4'
			},
		},
		invalid: {
			color: '#FF0000',
			iconColor: '#FF0000'
		}
	};

	const form = document.querySelector('[data-payment-form]');
	const card = elements.create('card', { style });
	const errorWrapper = document.querySelector('[data-stripe-errors]');
	const submitInput =  form.querySelector('button[type="submit"]');
	const paymentMethodInput = form.querySelector('input[name="' + form.dataset.paymentFormNamespace  + '[paymentMethodId]"]');
	
	card.mount('[data-stripe-payment-form]');
	card.on('change', (event) => errorWrapper.textContent = event.error ? event.error.message : '');
	
	form.addEventListener('submit', (e) => {
		
		e.preventDefault();

		submitInput.setAttribute('disabled', 'true');

		const paymentData = {
			billing_details: {
				email: form.dataset.cartEmail
			}
		};
		
		window.stripe.createPaymentMethod('card', card, paymentData).then((res) => {
			if (res.error) {
				errorWrapper.textContent = res.error.message;
				submitInput.removeAttribute('disabled');
			} else {
				paymentMethodInput.setAttribute('value', res.paymentMethod.id);
				form.submit();
			}
		});
		
	});
	
}

$(window).on('load', function(){
	headerHeight();
});

$(document).ready(function(){
	startDates();
	accordion();
	navToggle();
	modal();
	contentTriggers();
	initCheckoutForm();
	initPaymentForm();


	if ($(".js-testimonial-slider").length) {
		$('.js-testimonial-slider').slick({
			infinite: true,
			slidesToShow: 4,
			slidesToScroll: 1,
			dots: false,
			responsive: [
				{
					breakpoint: 1000,
					settings: {
						slidesToShow: 3,
						slidesToScroll: 1,
					}
				},
				{
					breakpoint: 700,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1
					}
				}
			]
		});
	}

});